import React from "react";
import { Box, Paper, Stack, Typography, Tab, Tabs } from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const CenteredTab = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Centered Tab
        </Typography>
        <Typography variant={"body1"} color={"text.primary"}>
          The centered prop should be used for larger views.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor  language={"js"} value={"              <Tabs value={value} onChange={handleChange} centered>\n" +
              "                <Tab label=\"Item One\" />\n" +
              "                <Tab label=\"Item Two\" />\n" +
              "                <Tab label=\"Item Three\" />\n" +
              "              </Tabs>"}>
            <Box sx={{ width: "100%" }}>
              <Tabs value={value} onChange={handleChange} centered>
                <Tab label="Item One" />
                <Tab label="Item Two" />
                <Tab label="Item Three" />
              </Tabs>
            </Box>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default CenteredTab;
